{
  "zh-CN": {
    "validations": {
      "required": "%{field} 字段是必填的",
      "min": "%{field} 字段至少需要 %{min} 个字符",
      "max": "%{field} 字段最多 %{max} 个字符",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "%{field} 字段必须是有效的电子邮件地址",
      "confirmed": "%{field} 字段不匹配",
      "numeric": "%{field} 字段只能包含数字",
      "between": "%{field} 字段必须在 %{min} 和 %{max} 之间",
      "min_value": "%{field} 字段必须为 %{min} 或更多",
      "url": "%{field} 字段不是有效的 URL"
    }
  }
}
